import api from "../../utils/ApiConfig";

export const fetchHeatmapCommandes = async (type = "both", dateFrom = null, dateTo = null) => {
  const params = { type };
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;
  const response = await api.get("/bo/heatmap/commandes", { params });
  return response.data;
};
